export const Logo = ({ size = 48, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="30" fill="#2BA3A0" />
    <circle cx="32" cy="32" r="30" stroke="#0A1426" strokeOpacity="0.25" strokeWidth="1.5" />
    {/* Leaf body */}
    <path
      d="M18 44C18 30 30 18 46 18C46 34 34 46 18 46V44Z"
      fill="#F5F3EE"
    />
    {/* Circuit veins */}
    <path d="M22 42L34 30" stroke="#0A1426" strokeWidth="2" strokeLinecap="round" />
    <path d="M28 36L24 36" stroke="#0A1426" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 34L30 30" stroke="#0A1426" strokeWidth="2" strokeLinecap="round" />
    <path d="M34 30L40 30" stroke="#0A1426" strokeWidth="2" strokeLinecap="round" />
    <path d="M34 30L34 24" stroke="#0A1426" strokeWidth="2" strokeLinecap="round" />
    <circle cx="22" cy="42" r="2" fill="#0A1426" />
    <circle cx="40" cy="30" r="2" fill="#D4AF5A" />
    <circle cx="34" cy="24" r="2" fill="#D4AF5A" />
    <circle cx="24" cy="36" r="1.6" fill="#0A1426" />
  </svg>
);

export default Logo;
